import { MultiSelect, Text, rem } from '@mantine/core';
import useSWR from 'swr';
import { getFetcher } from '../../../../../api/fetchers';
import { BiSolidDownArrow } from 'react-icons/bi';
import { useState } from 'react';
import { useEmployeeFormContext } from '../NewEmployeePage';

interface Tag {
  id: number;
  name: string;
}

export const TagsCard: React.FC = () => {
  const form = useEmployeeFormContext();
  const [selectedTags, setSelectedTags] = useState<string[]>([]);
  const icon = (
    <BiSolidDownArrow
      style={{ width: rem(10), height: rem(10), color: 'gray' }}
    />
  );

  const { data } = useSWR<{ content: Tag[] }>('/tags', getFetcher);

  const tagOptions =
    data?.content?.map(tag => ({
      value: tag.id.toString(),
      label: tag.name,
      id: tag.id,
    })) ?? [];

  const handleChangeTags = (values: string[]) => {
    setSelectedTags(values);
    form.setFieldValue('tags', []);

    tagOptions.forEach(tag => {
      if (values.includes(tag.value)) form.insertListItem('tags', tag.id);
    });
  };

  return (
    <>
      <label style={{ display: 'flex', alignItems: 'center' }}>
        <Text fw={700} size="lg" style={{ marginRight: '5px' }}>
          Tagy
        </Text>
      </label>
      <MultiSelect
        variant="default"
        radius="md"
        rightSection={icon}
        placeholder="vyberte tagy"
        value={selectedTags}
        data={tagOptions}
        onChange={values => {
          handleChangeTags(values);
        }}
      />
    </>
  );
};
